import { ref } from 'vue'

import { createSharedComposable } from '@vueuse/core'
import { type BaseFilter } from '@/modules/conversations/api/filters'

export default createSharedComposable(() => {
  type ModalType = 'public' | 'private'
  const showModal = ref<boolean | ModalType>(false)
  const editableFilter = ref<BaseFilter>()

  const openFilterModal = (type: ModalType) => {
    showModal.value = type
  }

  const editFilter = (type: ModalType, filter) => {
    editableFilter.value = filter
    openFilterModal(type)
  }

  const close = () => {
    showModal.value = false
    editableFilter.value = undefined
  }

  return {
    showModal,
    editableFilter,
    openFilterModal,
    editFilter,
    close,
  }
})
